import $ from 'jquery';
import attachEnterAsClick from 'utils/attachEnterAsClick';

const addSelector = '.dependant-item-add';

const dependantItemInit = (index, component) => {
    const removeSelector = '.dependant-item-remove';
    const $component = $(component);

    $component.on('click', removeSelector, () => {
        $component.addClass('is-hidden');
        if ($('.form-dependant-item.is-hidden').length >= 1) {
            $(addSelector).removeClass('is-hidden');
        }
        // clear form fields
        $component.find('input, select').val('');
        $component.find('input[type="radio"]').prop('checked', false);
    });
    attachEnterAsClick($(removeSelector));
};

$(() => {
    const $widget = $('.form-dependant-item');

    if ($widget.length) {
        $widget.each(dependantItemInit);
    }
});
